import { MutationTree } from 'vuex';
import ActionTypes from '@/constants/action-types';
import { UserState } from '@/store/modules/user/state';
import { AuthModel } from '@/models/UserModel';

const mutations: MutationTree<UserState> = {

  [ActionTypes.GuestSignIn](state: UserState, auth: AuthModel) {
    state.auth = auth;
  },

};

export default mutations;
